import CheckBlack from '../assets/icons/checkRing_black.svg'
import { Background, ButtonsContainer, HeroMainHeader, HeroNameHeader, ImageWrapper } from '../components/hero'
import HeroImg from '../assets/images/blueprints1.1.jpg'
import { H1, H3, Header20, Header24, Header64, Paragraph16, SubHeader16, SubHeader20 } from '../styles/typography'
import { BlackButton, BlueButton, OrangeButton } from '../components/atoms/button'
import { scrollToSection } from '../utils'
import { HeaderLink, SimpleLink } from '../components/atoms/link'
import { Typewriter } from 'react-simple-typewriter'
import HoverIcon from '../components/atoms/icon'

export function Hero() {
    return (
        <section id='hero'>
            <Background>
                <HeroMainHeader>
                    <HeroNameHeader>
                        <h1 style={{ color: '#1D334E' }}>DRAWING THE </h1>
                        <h1 style={{ color: '#FFBC5D' }}> FINE LINE</h1>
                        <h2 style={{ color: '#7F8274' }}>CRAFTING HOMES WITH CARE, CLARITY, AND CRAFTSMANSHIP</h2>
                    </HeroNameHeader>

                    <ButtonsContainer>
                        <HeaderLink to='#contact' onClick={() => scrollToSection('contact')}>
                            <BlueButton style={{ width: '184px', paddingRight: 'unset', paddingLeft: 'unset' }}>
                                <SubHeader16>Get A Free Estimate</SubHeader16>
                            </BlueButton>
                        </HeaderLink>
                        <HeaderLink to='/services'>
                            <BlueButton style={{ width: '184px' }}>
                                <SubHeader16>Our Services</SubHeader16>
                            </BlueButton>
                        </HeaderLink>
                    </ButtonsContainer>
                </HeroMainHeader>

                {/* <ImageContainer> */}
                <ImageWrapper src={HeroImg} />
                {/* </ImageContainer> */}
            </Background>
        </section>
    )
}
